import {
    ISRESULT,
    GET_DATA_MAIN_MENUAUTHORIZATION, GET_DATA_MAIN_MENUAUTHORIZATION_SUCCEEDED, REQUERT_MAIN_MENUAUTHORIZATION_FAILED, SET_DATA_MAIN_MENUAUTHORIZATION,
    GET_DATA_User,GET_DATA_User_SUCCEEDED,REQUERT_User_FAILED,SET_DATA_MAIN_PERMISSION,REQUERT_PERMISSION_FAILED
    //IndexImportHygen
} from './actionTypes';
//MainMenuAuthorization
export const GetDataMainMenuAuthorizationAction = () => {
    return {
        type: GET_DATA_MAIN_MENUAUTHORIZATION
    }
}
export const GetDataMainMenuAuthorizationSuccessAction = (DataMain) => {
    return {
        type: GET_DATA_MAIN_MENUAUTHORIZATION_SUCCEEDED,
        DataMain: DataMain
    }
}
export const RequertMainMenuAuthorizationFaileAction = (Err) => {
    return {
        type: REQUERT_MAIN_MENUAUTHORIZATION_FAILED,
        err: Err
    }
}

export const SetDataMainMenuAuthorizationAction = (DataMain) => {
    return {
        type: SET_DATA_MAIN_MENUAUTHORIZATION,
        DataMain: DataMain
    }
}

//get user
export const GetDataUserAction = () => {
    return {
        type: GET_DATA_User
    }
}
export const GetDataUserSuccessAction = (DataUser) => {
    return {
        type: GET_DATA_User_SUCCEEDED,
        DataUser: DataUser
    }
}
export const RequertUserFaileAction = (Err) => {
    return {
        type: REQUERT_User_FAILED,
        err: Err
    }
}
//quyền 
export const SetDataPermissionnAction = (DataMain) => {
    return {
        type: SET_DATA_MAIN_PERMISSION,
        DataMain: DataMain
    }
}
export const RequertPermissionFaileAction = (Err) => {
    return {
        type: REQUERT_PERMISSION_FAILED,
        err: Err
    }
}
export const IsResultAction = (isResult) => {
    return {
        type: ISRESULT,
        isResult: isResult
    }
}

//IndexUsingHygen